import { QueryFactory } from "../QueryFactory";
import { SDQuery_Types } from "../../../contracts";
export const QGetEventsByRegionIdAndSportId = QueryFactory(SDQuery_Types.GetEventsByRegionIdAndSportId);
//# sourceMappingURL=QGetEventsByRegionIdAndSportId.js.map